import React from "react";
import { Button } from "@/components/ui/button";
import { CalendarPlus } from "lucide-react";

interface BulkAddSessionsButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export const BulkAddSessionsButton: React.FC<BulkAddSessionsButtonProps> = ({
  onClick,
  disabled = false
}) => {
  return (
    <Button 
      onClick={() => {
        onClick();
      }} 
      size="sm" 
      variant="outline"
      disabled={disabled}
      className="flex items-center gap-1"
    >
      <CalendarPlus className="h-4 w-4" />
      Bulk add sessions
    </Button>
  );
};
